export {default as TaskItem} from './TaskItem.connect';
